(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tbc-product-overview"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    const link = event.target.closest('.tbc-product-overview a');
    if (!link) return;
    const details = document.getElementById(link.hash.slice(1));
    if (details) details.open = true;
  });
  } catch(e) { console.error(e); }
})();

})();
